<template>
  <div class="app-container">
    <div style="margin-bottom: 20px">
      <el-form
        ref="formSearch" :model="queryForm" label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$t('uploadFile.statisticsDate')">
              <!-- 统计日期 -->
              <el-date-picker
                v-model="queryDateTime"
                :end-placeholder="$t('operationCenter.endDate')"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                style="width: 100%"
                type="daterange"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('collectionCenter.region')">
              <el-select
                v-model="queryForm.params.regionId"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 州 -->
          <el-col :span="4">
            <el-form-item :label="$t('collectionCenter.state')">
              <el-select
                v-model="queryForm.params.states"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in StateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--客户-->
            <el-form-item :label="$t('newOrder.CustomerName')" name="customerIds">
              <el-select
                v-model="queryForm.params.customerIds"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                :remote-method="getCustomerPage"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                size="small"
                style="width: 100%"
                @focus="getCustomerPage()"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.customerAlias + '(' + item.username + ')'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <div>
              <el-button
                icon="el-icon-search"
                size="small"
                type="primary"
                @click="searchResources(1)"
              >{{ $t('operationCenter.Procurar') }}
              </el-button>
              <el-button icon="el-icon-refresh-left" size="small" @click="searchResources(2)">
                {{ $t('operationCenter.reset') }}
              </el-button>
              <el-button
                icon="el-icon-upload2" size="small" type="primary"
                @click="allExportOrder"
              >{{ $t('newOrder.export') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="tableOpeatioLabel">{{ $t('uploadFile.missedOperationStatistics') }}</div>
      <div class="flx-between">
        <div style="text-align: center; width: 20%">
          <div>{{ $t('trajectory.total') }}</div>
          <div class="tableOpeation">{{ missOperationStatisticsData.missTotal || 0 }}</div>
        </div>
        <div style="text-align: center; width: 20%">
          <div>{{ $t('home.collection') }}</div>
          <div class="tableOpeation">
            {{ missOperationStatisticsData.collectMissScanTotal || 0 }}
          </div>
        </div>
        <div style="text-align: center; width: 20%">
          <div>{{ $t('uploadFile.collectionLoading') }}</div>
          <div class="tableOpeation">
            {{ missOperationStatisticsData.collectLoadMissScanTotal || 0 }}
          </div>
        </div>
        <div style="text-align: center; width: 20%">
          <div>{{ $t('GlobalSetObj.arrive') }}</div>
          <div class="tableOpeation">
            {{ missOperationStatisticsData.arrivalMissScanTotal || 0 }}
          </div>
        </div>
        <div style="text-align: center; width: 20%">
          <div>{{ $t('GlobalSetObj.sender') }}</div>
          <div class="tableOpeation">
            {{ missOperationStatisticsData.shipmentMissScanTotal || 0 }}
          </div>
        </div>
      </div>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="80"
      />
      <el-table-column
        v-for="(item, ind) in columnList"
        :key="ind"
        :align="item.align"
        :min-width="item.width"
        :prop="item.prop"
        :show-overflow-tooltip="true"
      >
        <template slot="header">
          <div>{{ item.label }}</div>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('GlobalSetObj.operate')"
        align="center"
        fixed="right"
        width="100px"
      >
        <template slot-scope="scope">
          <!--编辑-->
          <el-tooltip
            :content="$t('customerManagements.detailTitle')"
            class="item"
            effect="dark"
            placement="top"
          >
            <i
              class="iconfont icon-a-zu1279 clickDetail"
              style="font-size: 24px"
              @click="clickDetail(scope.row)"
            />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0"
        @current-change="getCurrentTableData"
        @size-change="getSizeTableData"
      />
    </div>
    <!-- 包裹详情-->
    <el-drawer
      :title="$t('customerManagements.detailTitle')"
      :visible.sync="dialogVisible"
      center
      direction="ltr"
      size="1400px"
      @close="closeDrawer"
    >
      <packageDetail
        v-if="dialogVisible"
        ref="votesDetails"
        :package-detail-dta="packageDetailDta"
        :region-list="regionList"
        :state-list="StateList"
        @call-parent-method="parentMethod"
      />
    </el-drawer>
  </div>
</template>

<script>
import { getLgAreaListData, regionQueryList } from '@/api/orderApi';
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList';
import {
  missOperationExport,
  missOperationPage,
  missOperationStatistics
} from '@/api/newExpressAPI';
import { apiCustomerPage } from '@/api/customer';

export default {
  name: 'ReturnDataMonitoring',
  components: {
    packageDetail: () => import('./component/packageDetail')
  },
  data() {
    return {
      regionList: [],
      dialogVisible: false, // 详情弹窗
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          regionId: '',
          states: [],
          customerIds: [],
          startDate: '',
          endDate: ''
        }
      },
      tableData: [],
      total: 0,
      StateList: [], // 州
      columnList: [
        // 大区 Região
        { label: this.$t('collectionCenter.region'), prop: 'regionName', width: 100 },
        // 州
        { label: this.$t('collectionCenter.state'), prop: 'state', width: 130 },
        // 漏扫总数
        { label: this.$t('uploadFile.totalMissedScans'), prop: 'missTotal', width: 150 },
        // 揽收漏扫数
        { label: this.$t('uploadFile.collectionMissedScans'), prop: 'collectMissScan', width: 150 },
        // 总揽收数
        { label: this.$t('uploadFile.totalCollections'), prop: 'collectTotal', width: 160 },
        // 揽收漏扫率
        {
          label: this.$t('uploadFile.collectionMissedScanRate'),
          prop: 'collectMissScanRate',
          width: 160
        },
        // 揽收装车漏扫数
        {
          label: this.$t('uploadFile.collectionLoadingMissedScans'),
          prop: 'collectLoadMissScan',
          width: 160
        },
        // 揽收装车数
        {
          label: this.$t('uploadFile.collectionLoadingCount'),
          prop: 'collectLoadTotal',
          width: 170,
          typeNum: 1
        },
        // 装车漏扫率
        {
          label: this.$t('uploadFile.loadingMissedScanRate'),
          prop: 'collectLoadMissScanRate',
          width: 160,
          typeNum: 2
        },
        // 发件漏扫数
        {
          label: this.$t('uploadFile.dispatchMissedScans'),
          prop: 'shipmentMissScan',
          width: 160,
          typeNum: 3
        },
        // 发件数
        {
          label: this.$t('uploadFile.dispatchCount'),
          prop: 'shipmentTotal',
          width: 160,
          typeNum: 4
        },
        // 发件漏扫率
        {
          label: this.$t('uploadFile.dispatchMissedScanRate'),
          prop: 'shipmentMissScanRate',
          width: 160,
          typeNum: 5
        },
        // 到件漏扫数
        {
          label: this.$t('uploadFile.arrivalMissedScans'),
          prop: 'arrivalMissScan',
          width: 160,
          typeNum: 4
        },
        // 到件数
        { label: this.$t('uploadFile.arrivalCount'), prop: 'arrivalTotal', width: 160, typeNum: 4 },
        // 到件漏扫数
        {
          label: this.$t('uploadFile.arrivalMissedScanRate'),
          prop: 'arrivalMissScanRate',
          width: 160,
          typeNum: 4
        }
      ],
      queryDateTime: [this.getAWeek().startDate, this.getAWeek().endDate],
      packageDetailDta: {},
      customerList: [],
      missOperationStatisticsData: {}
    };
  },
  created() {
    // 获取加盟商选项
    this.getAddress();
    this.getTableData(1);
    this.getRegion();
  },
  methods: {
    clickDetail(row) {
      console.log(row, 'clickDetail');
      this.packageDetailDta = {
        regionId: row.regionId,
        states: row.state,
        customerIds: this.queryForm.params.customerIds,
        startDate: row.startDate,
        endDate: row.endDate
      };
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        this.packageDetailDta.startDate = this.queryDateTime[0];
        this.packageDetailDta.endDate = this.queryDateTime[1];
      }
      this.dialogVisible = true;
    },
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 大区
    getRegion() {
      regionQueryList(3).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    // 搜索、重置
    searchResources(type) {
      if (type === 1) {
        this.queryForm.pageNumber = 1;
        this.getTableData();
      } else {
        this.queryForm = {
          pageSize: 10,
          pageNumber: 1,
          params: {
            regionId: '',
            states: [],
            customerIds: [],
            startDate: '',
            endDate: ''
          }
        };
        this.queryDateTime = [this.getAWeek().startDate, this.getAWeek().endDate];
        this.getTableData();
      }
    },
    // 获取最近30天时间
    getAWeek() {
      return {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD')
      };
    },
    // 获取加盟商时效统计列表
    getTableData(val) {
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        this.queryForm.params.startDate = this.queryDateTime[0];
        this.queryForm.params.endDate = this.queryDateTime[1];
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      missOperationPage(this.queryForm)
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.records;
            this.tableData.forEach((item) => {
              item.date = item.date || '--';
            });
            if (val === 1) {
              loading.close();
            }
          }
        })
        .catch(() => {
          if (val === 1) {
            loading.close();
          }
        });
      // 获取加盟商时效统计列表
      missOperationStatistics(this.queryForm.params).then((res) => {
        if (res.code === 200) {
          console.log(res, 'missOperationStatistics');
          this.missOperationStatisticsData = res.data;
        }
      });
    },
    // getMissOperationStatistics() {
    //
    // },
    allExportOrder() {
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        this.queryForm.params.startDate = this.queryDateTime[0];
        this.queryForm.params.endDate = this.queryDateTime[1];
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      const data = this.queryForm.params;
      missOperationExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 页码变化翻页
    getCurrentTableData(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    },
    // 每页显示数量变化
    getSizeTableData(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getTableData();
    },
    closeDrawer() {
      this.dialogVisible = false;
    },
    parentMethod(arg) {
      this.dialogVisible = arg;
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.app-container >>> .el-drawer__header {
  margin-bottom: 10px;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 20px;
  color: black;
}

.tableOpeatioLabel {
  font-size: 18px;
  font-weight: bold;
  margin: 20px 0;
}

.tableOpeation {
  cursor: pointer;
  font-size: 26px;
  font-weight: bold;
  margin-top: 8px;
}

.clickDetail {
  color: #409eff;
  cursor: pointer;
  font-size: 24px;
}
</style>
